module.exports = __webpack_public_path__ + "static/media/dune.81a430b9.jpg";